import { render, staticRenderFns } from "./Progression.vue?vue&type=template&id=48ddc8f2&"
import script from "./Progression.vue?vue&type=script&lang=js&"
export * from "./Progression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports